import { Grid } from '@mui/material';
import { AutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical';
import { TopicAutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel';
import { MprcSwitch } from 'components/MprcSwitch';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TopicAutoCompleteHierarchical } from 'views/foundation/topic/components/TopicAutoCompleteHierarchical';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
}

////////////////////////////////////////////////////////////////////////////

export const AddTopic: React.FC<IProps> = (props) => {

    const { onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");

    const [selectedItem, setSelectedItem] = useState<TopicAutoCompleteHierarchicalModel>();
    const [onlyRequiredLink, setOnlyRequiredLink] = useState<boolean>(false);

    ////////////////////////////////////////////////////////////////////////////
    ///
    const onChange = (item: (AutoCompleteHierarchicalModel | TopicAutoCompleteHierarchicalModel)[]) => {
        if (item.length > 0) {
            setSelectedItem(item[0] as TopicAutoCompleteHierarchicalModel);
        } else {
            setSelectedItem(undefined);
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {

        const members = [];
        if (selectedItem != undefined) {
            if (onlyRequiredLink)
                members.push(selectedItem!.requiredGroup.id);
            else
                members.push(selectedItem!.optionalGroup.id);
        }

        onItemsChange(members);
    }, [selectedItem, onlyRequiredLink]);

    return <Grid container spacing={2} direction="column">
        <Grid>
            <TopicAutoCompleteHierarchical
                autoFocus
                selectedItems={selectedItem != undefined ? [selectedItem] : []}
                multiSelect={false}
                selectedMode="free"
                onChange={onChange}
                onError={onError}
                placeholder={t("Channel.Edit.Members.SelectTopicPlaceholder")}
            />
        </Grid>
        <Grid>
            <MprcSwitch
                label={t("Channel.Edit.Members.TopicRequiredLinkLabel")}
                checked={onlyRequiredLink}
                onChange={() => setOnlyRequiredLink(!onlyRequiredLink)}
                helperText={t("Channel.Edit.Members.TopicLinkHint")}
            />
        </Grid>
    </Grid>;
};
